import React from "react";
import * as c from "./dropdownSectionFeatures.module.scss";
import { graphql, Link, useStaticQuery } from "gatsby";
import FeatureIcon from "@components/shared/featureIcon";
import { createItemSortOrder } from "@utils/helpers";

const navItemOrder = {
  scheduling: 0,
  payments: 1,
  "client-management": 2,
  "online-booking": 3,
  "express-booking": 4,
  "two-way-texting": 5,
  "retail-and-inventory": 6,
  "staff-management": 7,
  "memberships-and-packages": 8,
  "integrated-forms": 9,
  "gift-cards": 10,
  "mobile-apps": 11,
  reporting: 12,
  "multi-location": 13,
  "automated-flows": 14,
  campaigns: 15,
  "offers-and-discounts": 16,
  "virtual-waiting-room": 17,
  "payroll-processing": 18,
};

const getDesktopSortOrder = createItemSortOrder(navItemOrder);

const getFeatureUrl = (slug) => {
  if (slug === "payments") {
    return "/payments/";
  }
  return `/features/${slug}/`;
};

const FeatureItem = ({ title, slug }) => {
  const url = getFeatureUrl(slug);
  return (
    <Link className={c.feature} to={url}>
      <FeatureIcon className={c.icon} slug={slug} />
      <div className={c.text}>
        <h4 className={c.title}>{title}</h4>
      </div>
    </Link>
  );
};

export default function DropdownSectionFeatures() {
  const { featurePages } = useStaticQuery(
    graphql`
      query {
        featurePages: allContentfulLandingPage(
          filter: {
            pageVariant: { in: ["Showcase Page", "Feature Page"] }
            slug: { nin: ["marketing-and-automation"] }
          }
        ) {
          nodes {
            slug
            title: navbarOverviewTitle
            navbarCategory
          }
        }
      }
    `
  );

  const sortedFeaturePages =
    featurePages?.nodes &&
    featurePages?.nodes.sort((a, b) => getDesktopSortOrder(a.slug) - getDesktopSortOrder(b.slug));

  return (
    <>
      <div className={c.featureColumn}>
        <h2 className={c.label}>Scheduling & Payments</h2>
        {sortedFeaturePages.map(
          (feature) =>
            feature.navbarCategory === "Scheduling & Payments" && (
              <FeatureItem key={feature?.slug} category={feature?.navbarCategory} {...feature} />
            )
        )}
      </div>
      <div className={c.featureColumn}>
        <h2 className={c.label}>Client Relationships</h2>
        {sortedFeaturePages.map(
          (feature) =>
            feature.navbarCategory === "Client Relationships" && (
              <FeatureItem key={feature?.slug} category={feature?.navbarCategory} {...feature} />
            )
        )}
      </div>
      <div className={c.featureColumn}>
        <h2 className={c.label}>Marketing & Automation</h2>
        {sortedFeaturePages.map(
          (feature) =>
            feature.navbarCategory === "Marketing & Automation" && (
              <FeatureItem key={feature?.slug} category={feature?.navbarCategory} {...feature} />
            )
        )}
      </div>
      <div className={c.featureColumn}>
        <h2 className={c.label}>Management</h2>
        {sortedFeaturePages.map(
          (feature) =>
            (feature.navbarCategory === "Management" || feature.title === "Integrations") && (
              <FeatureItem key={feature?.slug} category={feature?.navbarCategory} {...feature} />
            )
        )}
      </div>
    </>
  );
}
